import React from 'react';

import { EmailMagicLinkButton } from '../../../components/EmailMagicLinkButton';

import { Divider } from '@/components/OrDivider';
import { SocialSignUp } from '@/components/SocialSignUp';
import { SSOButtonVariant } from '@/modules/auth/types';
import { MagicLinkType } from '@/modules/login/types';

export function SignUpActions({ nonce }: { nonce: string }) {
  return (
    <>
      <div>
        <SocialSignUp
          ssoButtonVariant={SSOButtonVariant.EyeCatching}
          nonce={nonce}
        />
      </div>
      <Divider />
      <EmailMagicLinkButton type={MagicLinkType.SIGNUP} />
    </>
  );
}
